<template>
    <div
    class="request-item"
    :class="{ selected, fading: isFading }"
    @click="handleClick"
    >
    <img class="avatar" :src="request.user.image_url || '/default-avatar.png'" alt="Avatar" />

    <div class="info">
      <div class="top-row">
        <h3 class="name">{{ request.user.name || 'Без имени' }}</h3>
        <span class="time">{{ formatTime(request.time) }}</span>
      </div>

      <p class="comment">{{ request.comment }}</p>
      <div class="actions">
        <button class="decline-button" :disabled="loading" @click="handleDecline">
          {{ loading ? '...' : 'Отклонить' }}
        </button>
        <button class="accept-button" :disabled="loading" @click="handleAccept">
          {{ loading ? '...' : 'Принять' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>

import { ref } from 'vue';

const props = defineProps({
  request: {
    type: Object,
    required: true
  },
  selected: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(["accept", "decline", "select"]);

const selectedRequestId = ref(null);
const loading = ref(false);
const isFading = ref(false);

async function handleAccept() {
  loading.value = true;
  emit("accept", props.request.id);
  fadeOut();
}

async function handleDecline() {
  loading.value = true;
  emit("decline", props.request.id);
  fadeOut();
}

function fadeOut() {
  isFading.value = true;
  setTimeout(() => {
    isFading.value = false;
  }, 500);
}

function formatTime(dateString) {
  if (!dateString) return "";
  const date = new Date(dateString);
  const now = new Date();
  const diff = (now - date) / 1000;

  if (diff < 60) return `${Math.floor(diff)}s`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h`;

  return date.toLocaleDateString();
}

function handleClick() {
  emit("select", props.request.id);
}
</script>

<style scoped>
.request-item {
  display: flex;
  align-items: flex-start;
  padding: 12px 16px;
  border-radius: 14px;
  width: 360px;
  transition: background 0.2s ease, opacity 0.5s ease;
  cursor: default;
  opacity: 1;
}

.request-item.fading {
  opacity: 0;
}

.request-item:hover {
  background-color: var(--request-hover-bg);
}

.avatar {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  object-fit: cover;
  margin-right: 12px;
}

.info {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.name {
  font-size: 15px;
  font-family: "Eastman-Bold", sans-serif;
  margin: 0;
  color: var(--text-primary);
}

.time {
  font-size: 13px;
  color: #aaa;
  margin-left: 8px;
  white-space: nowrap;
}

.comment {
  font-size: 14px;
  font-family: "Eastman-Regular", sans-serif;
  color: var(--text-secondary);
  margin: 4px 10px 10px 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 300px;
}

.actions {
  display: flex;
  gap: 10px;
}

.decline-button {
  background-color: #ffecec;
  color: #d61f1f;
  border: none;
  padding: 6px 14px;
  border-radius: 999px;
  font-family: "Eastman-Bold", sans-serif;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.accept-button {
  background-color: #d7eaff;
  color: #2173e5;
  border: none;
  padding: 6px 14px;
  border-radius: 999px;
  font-family: "Eastman-Bold", sans-serif;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.decline-button:disabled,
.accept-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.request-item.selected {
  background-color: rgba(33, 115, 229, 0.07);
}

</style>